import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BatKollisjonskadeHolmeEllerSkjar,
        tekst: 'Kollisjon med holme eller skjær',
    },
    {
        id: KategoriSvarId.BatKollisjonskadeFlytendeGjenstand,
        tekst: 'Kjørte over en flytende gjenstand som skadet båten',
    },
    {
        id: KategoriSvarId.BatKollisjonskadeMedBryggeEllerFastland,
        tekst: 'Kollisjon med brygge eller fastland',
    },
    {
        id: KategoriSvarId.BatKollisjonskadeMedAnnenBat,
        tekst: 'Kollisjon med en annen båt',
    },
];

export const BatKollisjonsskade = () => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.BatKollisjonskadeHolmeEllerSkjar) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatGrunnstottEllerSkjar));
        } else if (svarId === KategoriSvarId.BatKollisjonskadeFlytendeGjenstand) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatHarTruffetFlytendeGjenstand));
        } else if (svarId === KategoriSvarId.BatKollisjonskadeMedBryggeEllerFastland) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatHarKollidertMedBryggeEllerFastland));
        } else if (svarId === KategoriSvarId.BatKollisjonskadeMedAnnenBat) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatHarKollidertMedAnnenBat));
        }
    };

    const goback = () => navigate(-1);

    return (
        <GruppeLandingsside
            title="Kollisjon"
            radioButtonsLabel="Hva beskriver hendelsen best?"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.BaatSkade}
            kategoriId="bat-kollisjon"
        />
    );
};
